import React from "react";
import { Row, Col, Form, Input, DatePicker, Select } from "antd";
import classes from "../Pages.module.css";
import dayjs from 'dayjs';

const { Option } = Select;

const FormRenderer = (props) => {
  console.log(props, "dfdff");

  const handleChange = (e, param) => {
    console.log(e.target.value);
    console.log(param);
    props.setData((data) => {
      const newdata = [...data["accountHeader"]];
      console.log(newdata);

      newdata[0][param] = e.target.value;

      return {
        ...data,
        accountHeader: newdata,
      };
    });
  };

  const handleSelectChange = (value, param) => {
    console.log(value);
    console.log(param);
    props.setData((data) => {
      const newdata = [...data["accountHeader"]];
      console.log(newdata);
     
      newdata[0][param] = value;
      return {
        ...data,
        accountHeader: newdata,
      };
    });
  };

  const handleDateChange = (date, dateString) => {
    props.setData((data) => {
      const newdata = [...data["accountHeader"]];
      newdata[0]["holiday_date"] = date ? date.format("DD-MM-YYYY") : null;
      console.log("New holiday date:", newdata[0]["holiday_date"]);
      return {
        ...data,
        accountHeader: newdata,
      };
    });
  }

  return (
    <Row className={classes["RowDE"]}>
      <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div style={{ padding: "0rem 0.5rem", fontSize: "0.7rem", fontWeight: "bold" }}>
               Holiday Date
               <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
<DatePicker
  style={{ width: '100%' }}
  value={props.data.holiday_date ? dayjs(props.data.holiday_date, "DD-MM-YYYY") : null}
  onChange={handleDateChange}
  format="YYYY-MM-DD"
/>
          </Form.Item>
        </Form>
      </Col>

      <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div style={{ padding: "0rem 0.5rem", fontSize: "0.7rem", fontWeight: "bold" }}>
                Occasion <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Occasion"
              value={props.data.occasion}
              onChange={(e) => handleChange(e, "occasion")}
              bordered={false}
              style={{
                width: "100%",
                backgroundColor: "white",
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>

      <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div style={{ padding: "0rem 0.5rem", fontSize: "0.7rem", fontWeight: "bold" }}>
                Holiday Type <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Select
              placeholder="Select Holiday Type"
              value={props.data.holiday_type}
              onChange={(value) => handleSelectChange(value, "holiday_type")}
              style={{ width: "100%" }}
            >
              {props.ad?.Holiday?.rows?.map((holiday) => (
                <Option
                  key={holiday.holiday_type_code}
                  value={holiday.holiday_type_code}
                  style={{ textTransform: "capitalize", color: "#1777C4" }}
                >
                  {holiday.holiday_type_desc}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Col>

      <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div style={{ padding: "0rem 0.5rem", fontSize: "0.7rem", fontWeight: "bold" }}>
                Religion <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Select
              placeholder="Select Religion"
              value={props.data.religion}
              onChange={(value) => handleSelectChange(value, "religion")}
              style={{ width: "100%" }}
            >
              {props.ad?.Religion?.rows?.map((religion) => (
                <Option
                  key={religion.religion_code}
                  value={religion.religion_code}
                  style={{ textTransform: "capitalize", color: "#1777C4" }}
                >
                  {religion.religion_desc}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Col>

      <Col span={8} style={{ margin: "auto" }}>
        {props.save && (
          <button
            onClick={(event) => props.handleSubmit(event)}
            className={classes["ProfileButtonF"]}
          >
            Add Record
          </button>
        )}
      </Col>
    </Row>
  );
};

export default FormRenderer;
